import { createFileRoute, notFound } from "@tanstack/react-router";
import NotFound from "@/pages/NotFound";
import { unavailableHead } from "@/lib/seoPolicy";

/** Catch unmatched tails so a valid prefix never lends its metadata to a 404. */
export const Route = createFileRoute("/_public/$")({
  loader: () => { throw notFound(); },
  head: unavailableHead,
  component: NotFound,
  notFoundComponent: NotFound,
  errorComponent: NotFound,
});